<template>
  <div>
    <template v-if="isPermission">
      <slot />
    </template>
    <template v-else>
      <v-card elevation="0" class="mt-3">
        <v-card-text class="text-center">
          <v-icon size="80">mdi-alert-circle-outline</v-icon>
          <h3 class="mt-4">{{ $t('project.sorry_you_do_not_have_permission_to_access_data') }}</h3>
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    marketId: String,
    rule: String,
  },
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
    isPermission(){
      if(this.admin){
        return true
      }else if(this.employee){
        if(this.rule == "enableViewAreas" && this.employee.enableViewAreas) return true
        else if(this.rule == "enableViewCustomers" && this.employee.enableViewCustomers) return true
        else if(this.rule == "enableViewBilling" && this.employee.enableViewBilling) return true
        else if(this.rule == "enableViewAccounting" && this.employee.enableViewAccounting) return true
        else if(this.rule == "enableViewReports" && this.employee.enableViewReports) return true
        else if(this.rule == "enableViewSettings" && this.employee.enableViewSettings) return true
        else if(this.rule == "enableViewAreaInterests" && this.employee.enableViewAreaInterests) return true
        else if(this.rule == "enableViewAppeal" && this.employee.enableViewAppeal) return true
        else if(this.rule == "enableViewOverall" && this.employee.enableViewOverall) return true
        else if(this.rule == "enableViewApprove" && this.employee.enableViewApprove) return true
        else if(this.rule == "enableApproveAreaInterest" && this.employee.enableApproveAreaInterest) return true
        else if(this.rule == "enableApproveSettingBilling" && this.employee.enableApproveSettingBilling) return true
        else if(this.rule == "enableApproveSettingAreaAccounting" && this.employee.enableApproveSettingAreaAccounting) return true
        else if(this.rule == "enableApproveCheckout" && this.employee.enableApproveCheckout) return true
        else if(this.rule == "enableViewIncomeExpense" && this.employee.enableViewIncomeExpense) return true
        else return false
      }else{
        return false
      }
    }
  },
};
</script>